import React, { ReactNode, useContext, useMemo } from 'react';
import { useServices } from 'hooks';
import { ServiceName } from './enabled-services-context-helper';

interface ServiceContextProviderProps {
    children: ReactNode;
}

const serviceContextObject = React.createContext<any>({
    isServiceEnabledFor: (): boolean => false,
});

interface ServiceContext {
    isServiceEnabledFor: (serviceName: ServiceName) => boolean;
}

const useServicesEnabled = (): ServiceContext =>
    useContext(serviceContextObject);

const ServiceContextProvider = ({
    children,
}: ServiceContextProviderProps): React.JSX.Element => {
    const { data, isLoading } = useServices();

    const isServiceEnabledFor = (serviceName: ServiceName): boolean => {
        return (
            !isLoading &&
            (data?.data?.enabledServices?.includes(serviceName) ?? false)
        );
    };

    const value = useMemo(
        () => ({
            isServiceEnabledFor: isServiceEnabledFor,
        }),
        [data, isLoading] // eslint-disable-line react-hooks/exhaustive-deps
    );

    return (
        <serviceContextObject.Provider value={value}>
            {children}
        </serviceContextObject.Provider>
    );
};

export { useServicesEnabled, ServiceContextProvider };
